module.exports = __webpack_public_path__ + "img/taili_ziidngyi.fb8e994a.png";